import React from 'react';

const FormSelect = ({ label, options, register, name, rules, errors, disabled = false, placeholder = 'Pilih salah satu...' }) => {
    const error = errors[name];

    return (
        <div className="flex flex-col mb-4">
            <label htmlFor={name} className="mb-1 text-sm font-medium text-gray-700">
                {label} {rules?.required && <span className="text-red-500">*</span>}
            </label>
            <select
                id={name}
                disabled={disabled}
                className={`px-3 py-2 border rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm disabled:bg-gray-100 disabled:text-gray-400 ${error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300'
                    }`}
                {...register(name, rules)}
            >
                <option value="">{placeholder}</option>
                {options.map((option) => (
                    <option key={option.id} value={option.id}>
                        {option.name}
                    </option>
                ))}
            </select>
            {error && (
                <span className="mt-1 text-xs text-red-500">{error.message}</span>
            )}
        </div>
    );
};

export default FormSelect;